import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

export class CollectionSeeMoreTag extends Component {

  constructor(props) {
    super(props)

    this.state = {
      tags: []
    }
  }


  componentDidMount() {
    const { data } = this.props
    if (data) {
      let preData = data.map(r => r.trim())
      let tags = preData.sort()
      this.setState({
        tags
      })
    }
  }

  render() {
    const { tags } = this.state
    return (
      <div className="tags-wrapper">
        {tags.length > 0 &&
          <ul>
            {tags.map((r, k) => <li key={k}><span>{r}</span></li>)}
          </ul>}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionSeeMoreTag)))